<template>
    <internal>
        <card-header :title="workshop.title+' By:'+workshop.faculty_name"></card-header>
        <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg" v-for="cls,index in workshop.classes" :key="index">
            <div class="flex justify-between">
                <p class="text-lg font-medium mb-4">{{cls.courseyear.duration.start_month}} > {{cls.courseyear.course.title}} > {{titleCase(cls.courseyear.title)}}</p>
                <div>
                    <span class="mx-2">{{cls.confirmcount}} Student(s) Confirmed</span>
                </div>
            </div>
            <breeze-table :fields="fields" :items="cls.students"  :canView="this.$page.props.auth.user.role.permissions.find(permission => permission.name === 'View Workshop')">
                <template #rollno="data">
                    {{data.item.student.roll_no}}
                </template>
                <template #student="data">
                    {{data.item.student.first_name}}  {{data.item.student.last_name}}
                </template>
                <template #paymentmode="data">
                    {{data.item.paymentmode.title}}
                </template>
                <template #receipt="data">
                    <a target="_blank" :href="data.item.receipt" :class="'mb-1'" class="mr-2 text-indigo-500">View</a>
                </template>
                <template #remark="data">
                    <breeze-input v-model="inputData[data.item.id]" v-if="data.item.status === 'pending'" />
                    <span v-else>{{data.item.remark}}</span>
                </template>
                <template #action="data">
                    <div v-if="data.item.status === 'pending'">
                        <breeze-button class="mr-2" type="button" @click="receiptAction('confirmed',data.item.id)">Confirm</breeze-button>
                        <breeze-button  type="button" @click="receiptAction('rejected',data.item.id)">Reject</breeze-button>
                    </div>
                    <span v-else>{{capitalize(data.item.status)}}</span>
                </template>
            </breeze-table>
        </div>
    </internal>
</template>

<script>
    import Internal from '@/Pages/Internal/Internal'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import SelectList from '@/Components/SelectList'
    import Exception from '@/Components/Exception'
    import BreezeTable from '@/Components/Table'

    export default {
        components: {
            Internal,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            BreezeTable,
            SelectList
        },
        props:['workshop'],
        data(){
            return{
                fields:[{'key':'rollno','label':'Roll No'},{'key':'student','label':'Student'},{'key':'paymentmode','label':'Payment Mode'},{'key':'receipt','label':'Receipt'},{'key':'remark','label':'Remark'},{'key':'action','label':'Action'}],
                branchid:localStorage.branchId,
                inputData:[],
            }
        },
        methods:{
            receiptAction(action,id){
                this.$inertia.post(route('internal.workshop.students.transaction',[this.branchid,this.workshop.id,id]),{action:action,remark:this.inputData[id]});
                location.reload();
            }
        }
    }
</script>
